import { render, staticRenderFns } from "./RedirectUrl.vue?vue&type=template&id=568b5804&"
import script from "./RedirectUrl.vue?vue&type=script&lang=js&"
export * from "./RedirectUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568b5804')) {
      api.createRecord('568b5804', component.options)
    } else {
      api.reload('568b5804', component.options)
    }
    module.hot.accept("./RedirectUrl.vue?vue&type=template&id=568b5804&", function () {
      api.rerender('568b5804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckylogin/components/RedirectUrl.vue"
export default component.exports